import http from '@/http'
const URL = '/admin/translations'

export const list = async (params) => {
  const list = (await http.get(URL, { params: params }))
  return list
}

export const groups = async () => {
  const list = (await http.get(URL + '/groups'))
  return list
}

export const byGroup = async (languageId, group) => {
  const list = (await http.get(URL + `/${languageId}/group/${group}`))
  return list
}

export const save = (payload) => {
  return http.post(URL, payload)
}

export const bulkUpdate = (payload) => {
  return http.post(URL + '/bulk', payload)
}

export const importTranslations = (payload) => {
  const formData = new FormData()
  formData.append('language_id', payload.language_id)
  formData.append('group', payload.group)
  formData.append('file', payload.file)
  return http.post(URL + '/import', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export const exportTranslations = async (languageId, group) => {
  let url = URL + `/${languageId}/export`
  if (group) {
    url += `?group=${group}`
  }
  const response = (await http.get(url))
  return response
}

export const copyTranslations = (payload) => {
  return http.post(URL + '/copy', payload)
}

export const deleteTranslation = async (id) => http.delete(URL + `/${id}`)

export default {
  list,
  groups,
  byGroup,
  save,
  bulkUpdate,
  importTranslations,
  exportTranslations,
  copyTranslations,
  deleteTranslation
}
